import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TutorialMatchStore {
  // Fake wager
  fakeWagerAmount: number;
  setFakeWagerAmount: (n: number) => void;

  // Tips
  tipsSkipped: boolean;
  skipAllTips: () => void;
  resetTips: () => void;

  // Combo reference drawer
  comboDrawerOpen: boolean;
  toggleComboDrawer: () => void;

  // Completion tracking (persisted)
  tutorialMatchesCompleted: number;
  mechanicsLearned: string[];
  incrementCompleted: () => void;
  markMechanicLearned: (id: string) => void;
}

export const useTutorialMatchStore = create<TutorialMatchStore>()(
  persist(
    (set) => ({
      // Fake wager
      fakeWagerAmount: 1,
      setFakeWagerAmount: (n) => set({ fakeWagerAmount: n }),

      // Tips
      tipsSkipped: false,
      skipAllTips: () => set({ tipsSkipped: true }),
      resetTips: () => set({ tipsSkipped: false }),

      // Combo reference drawer
      comboDrawerOpen: false,
      toggleComboDrawer: () => set((s) => ({ comboDrawerOpen: !s.comboDrawerOpen })),

      // Completion tracking
      tutorialMatchesCompleted: 0,
      mechanicsLearned: [],
      incrementCompleted: () =>
        set((s) => ({ tutorialMatchesCompleted: s.tutorialMatchesCompleted + 1 })),
      markMechanicLearned: (id) =>
        set((s) => ({
          mechanicsLearned: s.mechanicsLearned.includes(id)
            ? s.mechanicsLearned
            : [...s.mechanicsLearned, id],
        })),
    }),
    {
      name: 'solante-tutorial-match',
      partialize: (state) => ({
        tutorialMatchesCompleted: state.tutorialMatchesCompleted,
        tipsSkipped: state.tipsSkipped,
        mechanicsLearned: state.mechanicsLearned,
      }),
    },
  ),
);
